// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"2c41d653","210":"8a590a0f","405":"c45fcb9e","707":"6a8b113a","723":"dcabc9f0","791":"27fdf738"}[chunkId] + ".chunk.css";
};